import { actionShortcuts } from "../../actions";
import { useTunnels } from "../../context/tunnels";
import { useI18n } from "../../i18n";
import { ExitZenModeButton } from "../Actions";
import { useApp } from "../App";
import { HelpIcon } from "../icons";

import type { ActionManager } from "../../actions/manager";
import type { UIAppState } from "../../types";

const Footer = ({
  appState,
  actionManager,
  showExitZenModeBtn,
  defaultUIEnabled,
  zoomUIEnabled,
}: {
  appState: UIAppState;
  actionManager: ActionManager;
  showExitZenModeBtn: boolean;
  renderWelcomeScreen: boolean;
  defaultUIEnabled: boolean;
  zoomUIEnabled: boolean;
}) => {
  const { FooterCenterTunnel } = useTunnels();
  const { t } = useI18n();
  const app = useApp();
  return (
    <footer className="studio-footer" data-zen={appState.zenModeEnabled}>
      <div className="studio-navigation">
        {zoomUIEnabled && app.isNavigationEnabled() && (
          <div className="studio-zoom">
            {actionManager.renderAction("zoomOut")}
            {actionManager.renderAction("resetZoom")}
            {actionManager.renderAction("zoomIn")}
          </div>
        )}
        {defaultUIEnabled && !appState.viewModeEnabled && (
          <div className="studio-history">
            {actionManager.renderAction("undo")}
            {actionManager.renderAction("redo")}
          </div>
        )}
      </div>
      <div className="studio-footer-status">
        <FooterCenterTunnel.Out />
      </div>
      {defaultUIEnabled && (
        <button
          type="button"
          className="studio-help"
          title={t("helpDialog.title")}
          aria-label={t("helpDialog.title")}
          onClick={() => actionManager.executeAction(actionShortcuts)}
        >
          {HelpIcon}
        </button>
      )}
      {defaultUIEnabled && (
        <ExitZenModeButton
          actionManager={actionManager}
          showExitZenModeBtn={showExitZenModeBtn}
        />
      )}
    </footer>
  );
};
export default Footer;
